export default __webpack_public_path__ + "assets/MyriadPro-SemiboldIt.f75fdc4b.svg";